import React, { useState, useEffect } from 'react';
import { VscChromeClose } from 'react-icons/vsc'
// import { img } from "@chakra-ui/core";
import { useWeb3React } from "@web3-react/core";
import Modal from 'react-modal';
import swal from 'sweetalert';
import Web3EthContract from "web3-eth-contract";

import StakeContract from '../getAbis/stake.json'
import TokenContract from '../getAbis/token.json'
import { ethers } from 'ethers';

export default function StakePopUp({ isOpen, closeModal, updatePage, minStaking, totalStaked }) {
    const { account, active } = useWeb3React();

    const [stakeAmount, setStakeAmount] = useState(10);
    const [balance, setBalance] = useState(0)

    useEffect(() => {
        if (Number(stakeAmount) > balance && balance > minStaking) {
            setStakeAmount(balance)
        }
        console.log('stake amount', stakeAmount)
    }, [stakeAmount])

    const afterOpenModal = async () => {
        const { ethereum } = window;
        Web3EthContract.setProvider(ethereum);
        const contract_token = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);
        let balance = await contract_token.methods.balanceOf(account).call() / 10 ** 18
        let lockedAmount = await contract_token.methods.lockedAmount(account).call() / 10 ** 18
        let finalUserBal = Number(balance) - Number(lockedAmount)
        setBalance(finalUserBal)
    }
    const stakeTokens = async () => {
        const { ethereum } = window;
        Web3EthContract.setProvider(ethereum);
        const contract_stake = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);

        let finalAmount = ethers.utils.parseUnits(String(stakeAmount), 18);
        console.log("final amount ", finalAmount)

        if (stakeAmount < minStaking) {
            setStakeAmount(10)
            swal({
                title: "Error Found",
                text: "Stake atleast 10 tokens",
                icon: "error",
                showCancelButton: false,

                confirmButtonText: "Close",
                closeOnConfirm: false
            });
        } else {
            try {
                await contract_stake.methods.deposit(finalAmount).estimateGas({
                    from: account
                }).then(async function (gasAmount) {
                    await contract_stake.methods.deposit(finalAmount).send({
                        from: account
                    }, function (error, tx) {
                        if (error) {
                            swal({
                                title: "Error Found",
                                text: error.message,
                                icon: "error",
                                showCancelButton: false,

                                confirmButtonText: "Close",
                                closeOnConfirm: false
                            });
                        } else {
                            swal({
                                title: "Stake Request Submitted Successfully",
                                text: "Please wait for wallet confirmation.",
                                icon: "success",
                                showCancelButton: false,

                                confirmButtonText: "Close",
                                closeOnConfirm: false
                            });
                        }
                    });
                    updatePage()
                }).catch(function (error) {
                    swal({
                        title: "Error Found",
                        text: error.message,
                        icon: "error",
                        showCancelButton: false,

                        confirmButtonText: "Close",
                        closeOnConfirm: false
                    });
                })
            } catch (error) {
                swal({
                    title: "Error Found",
                    text: 'Insufficient Funds For Transaction',
                    icon: "error",
                    showCancelButton: false,

                    confirmButtonText: "Close",
                    closeOnConfirm: false
                });
            }
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={afterOpenModal}
            ariaHideApp={false}
            onRequestClose={closeModal}
            // style={customStyles}
            className="popupMain"
        >
            <div className="popupcenter">
                <div className="popheader">
                    <h3>Stake In Pool</h3>
                    <div className="close_icon"><VscChromeClose onClick={closeModal} /></div>
                </div>
                <div className="popbody">
                    <div>
                        <div className='d-flex justify-content-between'><h2>Min Stake : <span>{minStaking} TGC</span></h2></div>
                        <div className='d-flex justify-content-between mb-0 text-warning'>Stake :</div>
                        <div className='popup-input-wrapper'>
                            {/* <div className='d-flex justify-content-between'><p>Stake</p><p className='max' onClick={() => { setStakeAmount(4) }}>MAX</p></div> */}
                            <input type="number" className='w-100 bg-transparent text-white' value={stakeAmount} onChange={(e) => setStakeAmount(e.target.value)} />
                        </div>
                        <div className='d-flex justify-content-end mb-0 text-white text-right'>Balnce : {parseFloat(balance).toFixed(2)} TGC</div>
                        <br />
                        <div className='d-flex w-100'>
                            <button type='button' className='w-25' onClick={() => { setStakeAmount((25 / 100) * balance) }}>
                                25%
                            </button>
                            <button type='button' className='w-25' onClick={() => { setStakeAmount((50 / 100) * balance) }}>
                                50%
                            </button>
                            <button type='button' className='w-25' onClick={() => { setStakeAmount((75 / 100) * balance) }}>
                                75%
                            </button>
                            <button type='button' className='w-25' onClick={() => { setStakeAmount((100 / 100) * balance) }}>
                                100%
                            </button>
                        </div>
                        <div className='popup-button-group d-flex justify-content-between'>
                            {balance > 10 ?
                                <button type='button' className='w-100' onClick={() => {
                                    stakeTokens()
                                }}>
                                    Confirm
                                </button>
                                :
                                <button type='button' className='w-100' disabled>Insufficient TGC Tokens To Stake</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
